import React from 'react';
import PropTypes from 'prop-types';

import HeaderTitle from './HeaderTitle';
import ActionsSection from './ActionsSection';

const Header = ({selectedRowIds, globalFilter, setGlobalFilter, handleOpen}) => {
	return (
		<div className="d-lg-flex justify-content-between">
			<HeaderTitle globalFilter={globalFilter} setGlobalFilter={setGlobalFilter} />
			<div className="border-bottom border-200 my-3"></div>
			<ActionsSection selectedRowIds={selectedRowIds} handleOpen={handleOpen} />
		</div>
	);
};

Header.propTypes = {
	selectedRowIds: PropTypes.object,
	globalFilter: PropTypes.string,
	setGlobalFilter: PropTypes.func
};

export default Header;
